class CartItems extends HTMLElement {
    constructor() {
        super();

        this.cartCountDown = document.getElementById(`CartCountdown-${this.dataset.section}`)
        this.giftCardElement = document.getElementById('is-a-gift')
        this.giftCardButton = document.getElementById('cart-gift-wrapping')
        this.removeButtons = document.querySelectorAll('[data-cart-remove]')
        this.toCheckoutButton = document.getElementById('cart-checkout')
        this.couponCodeInput = document.getElementById('cart-coupon-code')
        this.cartNoteInput = document.getElementById('cart-note')
        this.checkTerms = document.getElementById('cart_conditions')
        this.phoneInput = document.getElementById('cart-phone')
        this.phoneError = document.getElementById('cart-phone-error')

        this.toCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this))
        this.initPhoneInput()

        this.initToCheckoutButtonDisabling()
        this.initCartCountdown()
        if (this.giftCardElement) this.initGiftCardElement()
        this.initGiftCardManipulation()
  }

    initGiftCardElement() {
        const isChecked = this.giftCardButton?.dataset.isChecked
        if (isChecked === 'true') {
            const variantId = this.giftCardButton?.dataset.giftId
            const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
            const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

            this.giftCardElement.style.display = 'none'
            giftCardRemoveButton?.addEventListener('click', () => {
                this.giftCardButton.dataset.isChecked = 'false'
            })

            giftCardQuantityInput?.addEventListener('change', (e) => {
                const value = Number(e.target.value)
                if (value  <= 0) {
                    this.giftCardButton.dataset.isChecked = 'false'
                }
            })
        } else {
          this.giftCardElement.style.display = 'flex'
        }
    }

    initGiftCardManipulation() {
        if (this.giftCardButton) {
            this.giftCardButton.removeEventListener('click', this.onAddGiftCardClick.bind(this))
            this.giftCardButton.addEventListener('click', this.onAddGiftCardClick.bind(this))
        }
    }

    onAddGiftCardClick(e) {
        e.preventDefault()
        e.stopPropagation()
        this.giftCardButton.dataset.isChecked = 'true'
    }

    initToCheckoutButtonDisabling() {
        if (this.checkTerms) {
            window.addEventListener('load', () => {
                this.toCheckoutButton.disabled = !this.checkTerms.checked
            })
        }
    }

    async handleToCheckoutPage(e) {

      if(window.is_wcp_wholesale_customer == true){return;} 
      
        e.preventDefault()

        // telefonul din coș ajunge precompletat la adresa de livrare din checkout
        const phone = this.getPhoneValue()
        if (phone === false) return

        if (phone) {
            try {
                localStorage.setItem('cartPhone', phone)
            } catch (error) {}

            try {
                await this.savePhoneToCheckout(phone)
            } catch (error) {
                console.error(`Error: ${error.message}`)
            }
        }

        try {
            // saving coupon
            const couponCode = this.couponCodeInput?.value 
            if (couponCode) {
                localStorage.setItem('storedDiscount', couponCode)
                const couponRes =  await fetch(`/discount/${couponCode}`)
                const text1 = await couponRes.text()
            }
            
            // saving cart note
            const cartNote = this.cartNoteInput?.value
            if (cartNote) {
                const cartNoteBody = JSON.stringify({ note: cartNote })
                const cartNoteRes = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body: cartNoteBody }})
                const text2 = await cartNoteRes.text()
            }

        } catch(error) {
            console.error(`Error: ${error.message}`)
        }

        let checkoutHref = this.toCheckoutButton.dataset.href;
        if (checkoutHref == null) {
            checkoutHref = `${window.routes?.root ? window.routes.root : ""}/checkout`;
        }
        
        window.location = checkoutHref;
    }

    initPhoneInput() {
        if (!this.phoneInput) return

        if (!this.phoneInput.value) {
            try {
                this.phoneInput.value = localStorage.getItem('cartPhone') || ''
            } catch (error) {}
        }

        this.phoneInput.addEventListener('input', () => this.showPhoneError(false))
    }

    // '' = câmp gol, false = număr invalid, altfel numărul în format +40...
    getPhoneValue() {
        if (!this.phoneInput) return ''

        const raw = this.phoneInput.value.trim()
        if (!raw) {
            this.showPhoneError(false)
            return ''
        }

        let phone = raw.replace(/[\s.\-()\/]/g, '')
        if (phone.startsWith('00')) phone = `+${phone.slice(2)}`
        else if (phone.startsWith('0')) phone = `+40${phone.slice(1)}`
        else if (phone.startsWith('40')) phone = `+${phone}`

        const isValid = phone.startsWith('+40') ? /^\+40\d{9}$/.test(phone) : /^\+[1-9]\d{7,14}$/.test(phone)
        if (!isValid) {
            this.showPhoneError(true)
            this.phoneInput.focus()
            return false
        }

        this.showPhoneError(false)
        return phone
    }

    showPhoneError(show) {
        if (!this.phoneError) return

        this.phoneError.textContent = show ? this.phoneInput.dataset.invalidMessage : ''
        this.phoneError.hidden = !show
        this.phoneInput.classList.toggle('is-invalid', show)
        this.phoneInput.setAttribute('aria-invalid', show)
    }

    // Storefront API (fără token) – coșul temei e același cu cel din checkout
    async savePhoneToCheckout(phone) {
        const cart = await fetch(`${window.routes?.root || ''}/cart.js`).then((res) => res.json())
        const query = `mutation($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {
            cartDeliveryAddressesReplace(cartId: $cartId, addresses: $addresses) {
                userErrors { message }
            }
        }`
        const variables = {
            cartId: `gid://shopify/Cart/${cart.token}`,
            addresses: [{
                selected: true,
                address: { deliveryAddress: phone.startsWith('+40') ? { phone, countryCode: 'RO' } : { phone } }
            }]
        }

        const res = await fetch('/api/2025-07/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query, variables })
        }).then((r) => r.json())

        const errors = res.errors || res.data?.cartDeliveryAddressesReplace?.userErrors
        if (errors?.length) console.error('Telefon checkout:', errors)
    }

    initCartCountdown(){
        if(!this.cartCountDown) return;

        if(!this.cartCountDown.classList.contains('is-running')){
            const duration = this.cartCountDown.getAttribute('data-cart-countdown') * 60
            const element = this.cartCountDown.querySelector('.time');

            this.cartCountDown.classList.add('is-running');
            this.startTimerCartCountdown(duration, element);
        }
    }

    startTimerCartCountdown(duration, element){
        var timer = duration, minutes, seconds, text;

        var startCoundown = setInterval(() => {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            text = minutes + ":" + seconds;

            element.innerText = text;

            if (--timer < 0) {
                clearInterval(startCoundown);
                this.cartCountDown.remove();
            }
        }, 1000);
    }
}

customElements.define('cart-items', CartItems);

class Accordion extends HTMLElement {
    constructor() {
        super();
        this.header = this.firstElementChild;
        this.content = this.lastElementChild;

        this.header.addEventListener('click', this.onSummaryClick.bind(this));
    }

    onSummaryClick(event) {
        event.preventDefault();
        this.hasAttribute('open') ? this.close() : this.open(event);
    }

    open(event) {
        this.setAttribute('open', true);
        this.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
        $(this.content).slideDown()
    }

    close() {
        this.removeAttribute('open');
        this.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
        $(this.content).slideUp()
    }
}

customElements.define('accordion-block', Accordion);

